import {Component, effect, Input, input, OnInit, output, signal, Signal} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormInputComponent } from '../../utils/form-input/form-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { PointMapComponent } from './point-map/point-map.component';
import { LocationModel, LocationType } from '../../../models/resources/location.model';
import {LocationService} from "../../../services/resources/location.service";
import {CheckboxInputComponent} from "../../utils/checkbox-input/checkbox-input.component";
import {FormSelectComponent} from "../../utils/form-select/form-select.component";

@Component({
  selector: 'app-address-form',
  imports: [
    ReactiveFormsModule,
    FormInputComponent,
    TranslateModule,
    PointMapComponent,
    CheckboxInputComponent,
    FormSelectComponent,
  ],
  templateUrl: './address-form.component.html',
  styleUrl: './address-form.component.scss',
})
export class AddressFormComponent implements OnInit{
  mapReady = false;

  formGroupOutput = output<FormGroup>();
  formGroup: Signal<FormGroup>;
  resource = input<LocationModel>();
  type = input<LocationType>();
  countries = [
    { key: 'Österreich', value: 'AT'},
    { key: 'Rumänien', value: 'RO' },
    { key: 'Ungarn', value: 'HU' } ];
  @Input() showNameField: boolean = true;
  @Input() showActiveStatus: boolean = true;
  @Input() lat = 48.2082;
  @Input() lng = 16.3738;

  constructor(
    private formBuilder: FormBuilder,
    public locationService: LocationService,
    ) {
    this.formGroup = signal(
      this.formBuilder.group({
        type: [null, [Validators.required]],
        name: [null, []],
        active: [true, []],

        address: this.formBuilder.group({
          country: [null, [Validators.required]],
          postcode: [null, [Validators.required]],
          place: [null, [Validators.required]],
          street: [null, [Validators.required]],
          houseNumber: [null, [Validators.required]],
          addressSuffix: [null],
        }),
        latitude: [null,
          [
            Validators.required,
            Validators.min(-90),
            Validators.max(90),
            Validators.pattern(/^-?\d{1,2}([.,]\d+)?$/),
          ],
        ],

        longitude: [null,
          [
            Validators.required,
            Validators.min(-180),
            Validators.max(180),
            Validators.pattern(/^-?\d{1,3}([.,]\d+)?$/),
          ],
        ],
      }),
    );

    effect(() => {
      this.formGroupOutput.emit(this.formGroup());
    });

    effect(() => {
      if (this.resource()) this.updateFormValues();
    });
  }

  ngOnInit(): void {
    this.formGroup().patchValue({
      type: this.type(),
      latitude: this.lat,
      longitude: this.lng,
    });
    this.formGroup().get('address.country')?.setValue('AT')
    this.mapReady = true;
  }

  onAddressSelected(data: {
    name?: string;
    lat: number;
    lng: number;
    postcode?: string;
    place?: string;
    street?: string;
    houseNumber?: string;
    addressSuffix?: string;
  }) {

    this.formGroup().patchValue({
      name: data.name ?? this.formGroup().get('name')!.value,
      latitude: data.lat,
      longitude: data.lng,
      address: {
        postcode: data.postcode ?? this.formGroup().get('address.postcode')!.value,
        place: data.place ?? this.formGroup().get('address.place')!.value,
        street: data.street ?? this.formGroup().get('address.street')!.value,
        houseNumber: data.houseNumber ?? this.formGroup().get('address.houseNumber')!.value,
        addressSuffix: data.addressSuffix ?? this.formGroup().get('address.addressSuffix')!.value,
      },
    });
  }

  updateFormValues() {
    const currentModel = this.resource();

    if (currentModel) {
      this.formGroup().patchValue({
        type: currentModel.type,
        name: currentModel?.name,
        active: currentModel.active,
        latitude: currentModel.latitude,
        longitude: currentModel.longitude,

      });
      this.formGroup().get('address')!.patchValue({
        country: currentModel.address.country,
        postcode: currentModel.address.postcode,
        place: currentModel.address.place,
        street: currentModel.address.street,
        houseNumber: currentModel.address.houseNumber,
        addressSuffix: currentModel.address.addressSuffix,
      });
    }
  }

  getAddressFormGroup(): FormGroup {
    return this.formGroup().get('address') as FormGroup;
  }
}
